// TIP-518 — Access / Claim section.
// "Find. Claim. Run it." with an illustrative Listing -> Claimed before/after.
// CTA routes to /search (the claim flow starts by finding your business).
import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "./Icon";

const ClaimVisual = () => (
  <div className="claim-visual" aria-hidden="true">
    <div className="claim-card claim-card--listing">
      <div className="claim-kicker"><span className="claim-kicker-dot" />Listing</div>
      <div className="claim-biz">Keecs Trading FZ</div>
      <div className="claim-sub">DMCC <span className="sep">·</span> Wholesale, Building Materials</div>
      <div className="claim-actions">
        <button className="claim-pill claim-pill--coral">Claim this business</button>
        <button className="claim-pill claim-pill--ghost">Buy Web Profile</button>
      </div>
    </div>

    <div className="claim-arrow">
      <Icon name="arrow-right" size={20} />
    </div>

    <div className="claim-card claim-card--claimed">
      <span className="claim-claimed-tag">Claimed</span>
      <div className="claim-biz">Keecs Trading FZ</div>
      <div className="claim-sub">Self-managed <span className="sep">·</span> Yours to edit</div>
      <div className="claim-actions">
        <button className="claim-pill claim-pill--white">Edit profile</button>
        <button className="claim-pill claim-pill--gold">Become a Member</button>
      </div>
    </div>
  </div>
);

const ClaimSection = () => {
  const navigate = useNavigate();
  return (
    <section data-component="AccessSection" className="section-dark">
      <div className="container-wide">
        <div className="sec-eyebrow"><span className="sec-eyebrow-dot" />Claim</div>
        <h2 className="sec-title-dark">Find. Claim. Run it.</h2>

        <div className="dark-split split-claim">
          <div>
            <p className="dark-lead">
              Your business already has a Listing on TREVEX, pulled from licensing data. Claiming it is free and takes about three minutes. Once claimed, you edit what is shown, you reply to what is asked, and it is yours to manage.
            </p>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => navigate("/search")}
              style={{ marginTop: 28, height: 48, padding: "0 22px", fontSize: 14.5 }}
            >
              Claim yours <Icon name="arrow-right" size={14} />
            </button>
          </div>
          <ClaimVisual />
        </div>
      </div>
    </section>
  );
};

export default ClaimSection;
